<template>
    <div class="anchor-help-center">
        <xi-top></xi-top>
        <div class="center-wrapper">
            <div class="center-menu-wrapper">
                <router-link @click.native="menuIndex=0;" :class="{'top-menu-chosen': menuIndex === 0}" :to="{name: 'copyrighterAboutPlatform'}" class="center-menu-item">
                    <div class="sticker"></div><i class="icon icon-20 icon-help-center-about-platform"></i><span>了解平台</span>
                </router-link>
                <router-link @click.native="menuIndex=1;" :class="{'top-menu-chosen': menuIndex === 1}" :to="{name: 'helpCenterCopyrighterSignIn'}" class="center-menu-item">
                    <div class="sticker"></div><i class="icon icon-20 icon-help-center-sign-in"></i><span>入驻平台</span>
                </router-link>
                <router-link @click.native="menuIndex=2;" :class="{'top-menu-chosen': menuIndex === 2}" :to="{name: 'helpCenterCopyrightManagement'}" class="center-menu-item">
                    <div class="sticker"></div><i class="icon icon-20 icon-help-center-copyright-management"></i><span>版权管理</span>
                </router-link>
                <router-link @click.native="menuIndex=3;" :class="{'top-menu-chosen': menuIndex === 3}" :to="{name: 'helpCenterTaskManagement'}" class="center-menu-item">
                    <div class="sticker"></div><i class="icon icon-20 icon-help-center-task-management"></i><span>任务管理</span>
                </router-link>
            </div>
            <div class="center-right">
                <router-view></router-view>
            </div>
        </div>
        <xi-footer></xi-footer>
    </div>
</template>
<script>
  import axios from 'axios';
  import XiFooter from '../../components/Footer.vue';
  import XiTop from '../../components/Top.vue';
  export default {
    components: {
      axios,
      XiFooter,
      XiTop
    },
    data() {
      return {
        menuIndex: 0,
        subMenuIndex: -1,
      }
    },
    methods: {
      initMenuIndex() {
        const name = this.$route.name;
        if (name === 'copyrighterAboutPlatform') this.menuIndex = 0;
        else if (name === 'helpCenterCopyrighterSignIn') this.menuIndex = 1;
        else if (name === 'helpCentercopyrightManagement') this.menuIndex = 2;
        else if (name === 'helpCenterTaskManagement') this.menuIndex = 3;
      }
    },
    computed: {

    },
    beforeMount() {
      this.initMenuIndex();
    },
    beforeUpdate() {
      this.initMenuIndex();
    }
  }

</script>
<style lang="sass" scoped>
    @import "../../../sass/help-center.scss";
    @import "../../../sass/icons.scss";
</style>



// WEBPACK FOOTER //
// CopyrighterHelpCenter.vue?f40166fa